import { useState } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
  ClassicEditor,
  Autoformat,
  BlockQuote,
  Bold,
  Essentials,
  Heading,
  Italic,
  Link,
  List,
  Image,
  ImageResize,
  ImageUpload,
  Paragraph,
  PasteFromOffice,
  Underline
} from 'ckeditor5';
import 'ckeditor5/ckeditor5.css';
import styles from './CKEditor.module.scss';

interface ICKEditorSharedProps {
  onChangeDescription: (newDescription: string) => void;
  description: string;
  saveDescription?: () => void;
  placeHolder: string;
  taskId?: string;
  customToolbar?: React.ReactNode[];
}

export const CKEditorShared = ({ 
  description, 
  onChangeDescription, 
  saveDescription, 
  placeHolder,
  customToolbar = []
}: ICKEditorSharedProps) => {
  const [onEditor, setOnEditor] = useState(false);

  return (
    <div className={styles.editor} data-oneditor={onEditor}>
      <div className={styles.toolbar}>
        {customToolbar}
      </div>
      <CKEditor
        editor={ClassicEditor}
        data={description}
        config={{
          licenseKey: 'GPL',
          plugins: [
            Autoformat,
            BlockQuote,
            Bold,
            Essentials,
            Heading,
            Image,
            ImageResize,
            ImageUpload,
            Italic,
            Link,
            List,
            Paragraph,
            PasteFromOffice,
            Underline
          ],
          toolbar: [
            'undo',
            'redo',
            '|',
            'heading',
            '|',
            'bold',
            'italic',
            'underline',
            '|',
            'link',
            'blockQuote',
            '|',
            'bulletedList',
            'numberedList',
          ],
          placeholder: placeHolder,
        }}
        onChange={(_, editor) => {
          const data = editor.getData();
          onChangeDescription(data);
        }}
        onBlur={() => {
          setOnEditor(false);
          saveDescription?.();
        }}
        onFocus={() => {
          setOnEditor(true);
        }}
      />
    </div>
  );
};
